import { CONFIG_SET } from "../actions/actionTypes";

const initialState = {
    configSet : 0
}

const configSet = (state = initialState , action) =>{
    switch(action.type){
        case CONFIG_SET : 
            return {
                ...state,
                ...{
                    configSet : state.configSet + 1
                }


            }

        default: return state;
    }

   
}

export default configSet;